/**
 * Storage Risk Alert — 型・スキーマ derivation 層
 *
 * 実際の Contract（ルーティング含む）は `@standandforce/api-contract` の
 * `storageRiskAlertContract` を真実源とし、`client.ts` がそこから直接 import する
 * （本ファイルは `appContract` には配線しない）。
 *
 * backend公開パッケージは `RiskLevel`/`PatternCode` 等の個別 enum を standalone export
 * していないため、本ファイルは公開スキーマの `.shape` から導出した薄い互換レイヤーを提供する。
 * 「契約を単一の正とし値セットの独立定義を避ける」既存パターン（M-1、`RiskLevelSelect.tsx` 等）を
 * 維持するための層であり、ハンドコピーではなく `.shape` 参照のため publish 版とのドリフトは
 * 発生しない。
 */
import { ListStorageRiskAlertsQuerySchema, StorageRiskAlertItemSchema } from '@standandforce/api-contract';
import type { StorageRiskAlertCount } from '@standandforce/api-contract';
import type { z } from 'zod';
export const RiskAlertCategorySchema = StorageRiskAlertItemSchema.shape.riskCategory;
export const RiskLevelSchema = StorageRiskAlertItemSchema.shape.riskLevel;
export type RiskLevel = z.infer<typeof RiskLevelSchema>;
export const RiskAlertPatternCodeSchema = StorageRiskAlertItemSchema.shape.patternCode;
export type RiskAlertPatternCode = z.infer<typeof RiskAlertPatternCodeSchema>;
export const ListStorageRiskAlertsOrderByEnum = ListStorageRiskAlertsQuerySchema.shape.orderBy.unwrap();
export type ListStorageRiskAlertsOrderBy = z.infer<typeof ListStorageRiskAlertsOrderByEnum>;
export { ListStorageRiskAlertsQuerySchema };
export type RiskAlert = z.infer<typeof StorageRiskAlertItemSchema>;
export type CountStorageRiskAlertsOutput = StorageRiskAlertCount;